import { a } from './chunk-IMSWER4T.js';

var m=(r=>(r.BOL="bol",r.AMAZON="amazon",r))(m||{});var t=class{_client=a.instance;async authorizeUser(e,r){return (await this._client.post(r,{module_id:e})).data}};

export { m as a, t as b };
//# sourceMappingURL=chunk-MGZGFIA6.js.map
//# sourceMappingURL=chunk-MGZGFIA6.js.map